export default __webpack_public_path__ + "static/media/trash.ceafcffb.svg";